import React from "react";

import { studentActions } from "../actions";

import { personasActions } from "../../personas/actions";

import { connect } from "react-redux";

import { StudentBadge } from "../components/StudentBadge";
import { RelativesCard } from "../../personas/components/RelativesCard";
import { PersonaDataCard } from "../../personas/components/PersonaDataCard";
import { Spinner } from "components/Icons/Spinner";
import { Row, Col } from "reactstrap";
import ReactDatetime from "react-datetime";
import { Link } from "react-router-dom";
// HACK BOLETINES 2021
import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";
import { Button } from "reactstrap";

import { AttendanceListCard } from "../components/AttendanceListCard";
var studentService = require("../api");

var viewActions = require("store/view.actions");

class StudentPage extends React.Component {
  componentDidMount() {
    this.props.getStudentBrief(
      this.props.token,
      this.props.match.params.id,
      this.props.currentCalendarID
    );
    this.props.getStudentAttendance(
      this.props.token,
      this.props.match.params.id,
      this.props.currentCalendarID
    );

    this.props.setMainTitle("Ficha individual", this.reports);
  }

  constructor(props) {
    super(props);
    this.state = {
      fechaCertificado: new Date("2021-12-17T00:00:00.000"),
    };
  }

  reports = [
    {
      id: "DOWNLOAD_EVAL_REPORT",
      label: "Descargar Boletín",
      action: this.downloadBoletin.bind(this),
    },
    {
      id: "DOWNLOAD_EVAL_REPORT_EXTRA",
      label: "Descargar Boletín Extraprogramatico",
      action: this.downloadBoletinExtraprog.bind(this),
    },
  ];

  generacionCertificadoFinCurso() {
    return (
      <>
        <button
          onClick={() => {
            studentActions.getCertificadoEgreso(
              this.props.student,
              this.state.fechaCertificado
            );
          }}
        >
          Certificado Fin Curso
        </button>
        <ReactDatetime
          inputProps={{
            className: "form-control",
            placeholder: "Ingrese fecha",
          }}
          timeFormat={false}
          closeOnSelect={true}
          locale="es-ar"
          onChange={(sel) => this.setState({ fechaCertificado: sel._d })}
          defaultValue={this.state.fechaCertificado}
        />
      </>
    );
  }
  // Descarga de boletin

  downloadCalifReport(extra) {
    viewActions.notification({
      message:
        "El documento ya se esta generando, luego de unos segundos iniciará la descarga.",
      title: "Descarga",
      type: "success",
    });

    studentService
      .getStudentEvaluationReport(
        this.props.token,
        this.props.student.course.course_id,
        this.props.match.params.id,
        this.props.currentCalendarID,
        extra
      )
      .then((json) => {
        const { vfs } = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        const documentDefinition = {
          pageSize: "A4",
          pageOrientation: "portrait",
          pageMargins: [40, 70, 40, 60],

          header: json.pageHeader,
          content: [
            json.studentHeader,
            json.logbook,
            json.attendance,
            json.signatures,
            json.footerNotes,
          ],
          footer: json.pageFooter,
          styles: json.styles,
        };
        pdfMake.createPdf(documentDefinition).open();
      });
  }

  downloadBoletin() {
    this.downloadCalifReport(0);
  }

  downloadBoletinExtraprog() {
    this.downloadCalifReport(1);
  }

  render() {
    return (
      <>
        <div className="content">
          {!this.props.view.loadingModules.getStudentBrief ? (
            <Row>
              <Col md="4">
                <StudentBadge
                  persona={this.props.student.persona}
                  course={this.props.student.course}
                  tags={this.props.student.tags}
                  roles={this.props.student.roles}
                />
                {this.props.student.roles &&
                (this.props.student.roles.includes("TUTOR") ||
                  this.props.student.roles.includes("TEACHER")) ? (
                  "PROFE"
                ) : (
                  <>
                    <RelativesCard
                      personaID={this.props.match.params.id}
                      docNbr={this.props.student.persona && this.props.student.persona.doc_nbr}
                      relatives={this.props.student.relatives}
                      removeRelated={this.props.deleteRelatedRelation}
                      addRelated={this.props.addRelatedRelation}
                    />
                    {/* HACK MATRICULACION */}
                    <Link
                      to={
                        "/admin/enroll/" +
                        (this.props.student.persona &&
                          this.props.student.persona.persona_id)
                      }
                    >
                      <Button color="success" size="sm">
                        Matricular 2026
                      </Button>
                    </Link>
                  </>
                )}

                {this.props.student.course &&
                  this.props.student.course.level_id ===
                    "4b451b5f-f343-11eb-8e37-069175aa36ca" && (
                    <>
                      <br />
                      {this.generacionCertificadoFinCurso()}
                    </>
                  )}
              </Col>
              <Col md="8">
                <PersonaDataCard
                  token={this.props.token}
                  persona={this.props.student.persona}
                  updatePersona={this.props.updatePersona}
                  isSaving={
                    this.props.view.loadingModules.savingPersonaDataCard
                  }
                />
                {this.props.student.roles &&
                  !this.props.student.roles.includes("TUTOR") &&
                  !this.props.student.roles.includes("TEACHER") && (
                    <AttendanceListCard
                      attendanceList={this.props.studentAttendance}
                      persona={this.props.student.persona}
                    />
                  )}
              </Col>
            </Row>
          ) : (
            <Spinner size="XL" />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.session.jwt_token,
    currentCalendarID: state.school.currentCalendarID,
    student: state.students.student,
    studentAttendance: state.students.studentAttendance,
    view: state.view,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStudentBrief: (token, personaID, calendarID) => {
      dispatch(studentActions.getStudentBrief(token, personaID, calendarID));
    },

    getStudentAttendance: (token, personaID, calendarID) => {
      dispatch(
        studentActions.getStudentAttendance(token, personaID, calendarID)
      );
    },

    setCurrentProfileImage: (token, personaID, fileUrl) => {
      dispatch(
        personasActions.setCurrentProfileImage(token, personaID, fileUrl)
      );
    },
    removeProfileImage: (token, personaID, id) => {
      dispatch(personasActions.removeProfileImage(token, personaID, id));
    },
    setMainTitle: (title, menu) => {
      dispatch(viewActions.setMainTitle(title, menu));
    },
    updatePersona: (token, personaID, data) => {
      dispatch(personasActions.updatePersona(token, personaID, data, false));
    },
    deleteRelatedRelation: (token, studentID, relatedID, isMyProfile) => {
      dispatch(
        personasActions.deleteRelatedRelation(
          token,
          studentID,
          relatedID,
          isMyProfile
        )
      );
    },
    addRelatedRelation: (
      token,
      studentID,
      relatedID,
      relationType,
      isMyProfile,
      rel
    ) => {
      dispatch(
        personasActions.addRelatedRelation(
          token,
          studentID,
          relatedID,
          relationType,
          isMyProfile,
          rel
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentPage);
